import { useLocation } from "react-router-dom";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ExpiredSessionModal } from "@hopper-b2b/ui";
import config from "../../utils/config";
import { PATH_AUTH_INVALID_SESSION } from "../../utils/urlPaths";
import Header from "../Header";
import "./styles.scss";

const ExpiredSession = () => {
  const { t } = useI18nContext();
  const location = useLocation();
  const open = location.pathname === PATH_AUTH_INVALID_SESSION;

  const onClick = () => {
    window.parent.postMessage(
      {
        type: "FINISH_SESSION",
        payload: null,
      },
      config.UBER_URL
    );
  };

  return (
    <div className="uber-invalid-session-container main-body desktop-top-margin">
      <Header />
      <ExpiredSessionModal
        className="uber-invalid-session-modal"
        open={open}
        title={t("expiredSessionModal.title")}
        description={t("expiredSessionModal.description")}
        buttonLabel={t("expiredSessionModal.confirm")}
        onConfirm={onClick}
      />
    </div>
  );
};

export default ExpiredSession;
